import { bootstrap } from 'angular';

import { AppModule } from './app.module';

bootstrap(document, [ AppModule.name ], { strictDi: true });



// WEBPACK FOOTER //
// ./app/index.ts